import type { Language } from "../../contexts/LanguageContext";

export const metricsLabels: Record<Language, {
  overview: { selectItem: string };
  common: {
    loading: string;
    none: string;
  };
  filters: {
    professionalPlaceholder: string;
    allProfessionals: string;
    periodPlaceholder: string;
    searchPlaceholder: string;
    emptyMessage: string;
    period: {
      month: string;
      last7: string; last15: string; last30: string; last90: string; last180: string; last365: string;
    };
  };
    dashboard: {
      totalAppointments: string;
      totalRevenue: string;
      vsPrevious: string;
      plansNote: string;
      plans: {
      active: string;
      late: string;
      paid: string;
    };
    tooltipName: string; // Fallback label for stacked bar "Total"
  };
}> = {
  pt: {
    overview: { selectItem: "Selecione um item de métricas." },
    common: { loading: "Carregando...", none: "Nenhum dado encontrado." },
    filters: {
      professionalPlaceholder: "Selecione um profissional",
      allProfessionals: "Todos os profissionais",
      periodPlaceholder: "Período",
      searchPlaceholder: "Buscar...",
      emptyMessage: "Nenhum item encontrado.",
      period: {
        month: "Este mês",
        last7: "Últimos 7 dias",
        last15: "Últimos 15 dias",
        last30: "Últimos 30 dias",
        last90: "Últimos 3 meses",
        last180: "Últimos 6 meses",
        last365: "Último ano",
      },
    },
    dashboard: {
      totalAppointments: "Total de consultas",
      totalRevenue: "Receita total",
      vsPrevious: "em relação ao período anterior",
      plansNote: "Estes valores usam apenas o filtro de período (não filtram por profissional)",
      plans: {
        active: "Planos ativos",
        late: "Pagamentos atrasados",
        paid: "Pagamentos finalizados",
      },
      tooltipName: "Total",
    },
  },
  en: {
    overview: { selectItem: "Select a metrics item." },
    common: { loading: "Loading...", none: "No data found." },
    filters: {
      professionalPlaceholder: "Select a professional",
      allProfessionals: "All professionals",
      periodPlaceholder: "Period",
      searchPlaceholder: "Search...",
      emptyMessage: "No items found.",
      period: {
        month: "This month",
        last7: "Last 7 days",
        last15: "Last 15 days",
        last30: "Last 30 days",
        last90: "Last 3 months",
        last180: "Last 6 months",
        last365: "Last year",
      },
    },
    dashboard: {
      totalAppointments: "Total appointments",
      totalRevenue: "Total revenue",
      vsPrevious: "vs previous period",
      plansNote: "These values use only the period filter (not filtered by professional)",
      plans: {
        active: "Active plans",
        late: "Late payments",
        paid: "Completed payments",
      },
      tooltipName: "Total",
    },
  },
};

